<template>
  <div id="box">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'box'
}
</script>

<style lang="less" scoped>
</style>